export default __webpack_public_path__ + "static/media/mailbox.a2e187e7.svg";